(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.astonInitialized === 'true') return;

      const scroller = root.querySelector('[data-aston-scroller]');
      const track = root.querySelector('[data-aston-track]');
      const cards = root.querySelectorAll('[data-aston-card]');
      const control = root.querySelector('[data-aston-motion-control]');

      if (!scroller || !track || cards.length < 2) return;
      root.dataset.astonInitialized = 'true';

      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplayEnabled = root.dataset.autoplay === 'true';
      const configuredSpeed = Number(root.dataset.speed) || 30;
      const pixelsPerFrame = configuredSpeed / 100;
      let direction = 1;
      let frameId;
      let userPaused = false;
      let interactionPaused = false;
      let visible = true;

      const canMove = () => (
        autoplayEnabled &&
        !mobileQuery.matches &&
        !reducedMotionQuery.matches &&
        !userPaused &&
        !interactionPaused &&
        visible
      );

      const updateControl = () => {
        if (!control) return;
        const paused = userPaused || reducedMotionQuery.matches;
        control.setAttribute('aria-pressed', String(paused));
        control.setAttribute('aria-label', paused ? 'Play product carousel' : 'Pause product carousel');
        control.querySelector('[data-aston-pause-label]').hidden = paused;
        control.querySelector('[data-aston-play-label]').hidden = !paused;
      };

      const updateTransforms = () => {
        if (mobileQuery.matches || reducedMotionQuery.matches) {
          cards.forEach((card) => card.style.removeProperty('transform'));
          return;
        }

        const scrollerRect = scroller.getBoundingClientRect();
        const center = scrollerRect.left + scrollerRect.width / 2;

        cards.forEach((card) => {
          if (card.matches(':hover') || card.matches(':focus-within')) return;
          const cardRect = card.getBoundingClientRect();
          const distance = ((cardRect.left + cardRect.width / 2) - center) / (scrollerRect.width / 2);
          const clamped = Math.max(-1, Math.min(1, distance));
          const rotateY = clamped * 14;
          const translateY = Math.abs(clamped) * 10;
          const scale = 1 - Math.abs(clamped) * 0.035;
          card.style.transform = `rotateY(${rotateY}deg) translateY(${translateY}px) scale(${scale})`;
        });
      };

      const animate = () => {
        if (canMove()) {
          const maxScroll = scroller.scrollWidth - scroller.clientWidth;
          scroller.scrollLeft += pixelsPerFrame * direction;

          if (scroller.scrollLeft >= maxScroll - 1) direction = -1;
          if (scroller.scrollLeft <= 1) direction = 1;
        }

        updateTransforms();
        frameId = window.requestAnimationFrame(animate);
      };

      const pauseForInteraction = () => {
        interactionPaused = true;
      };

      const resumeAfterInteraction = () => {
        interactionPaused = false;
      };

      control?.addEventListener('click', () => {
        userPaused = !userPaused;
        updateControl();
      });

      scroller.addEventListener('mouseenter', pauseForInteraction);
      scroller.addEventListener('mouseleave', resumeAfterInteraction);
      scroller.addEventListener('focusin', pauseForInteraction);
      scroller.addEventListener('focusout', resumeAfterInteraction);
      scroller.addEventListener('pointerdown', pauseForInteraction, { passive: true });
      scroller.addEventListener('pointerup', resumeAfterInteraction, { passive: true });
      scroller.addEventListener('scroll', updateTransforms, { passive: true });

      const observer = new IntersectionObserver((entries) => {
        visible = entries[0]?.isIntersecting ?? true;
      }, { threshold: 0.05 });
      observer.observe(root);

      const handlePreferenceChange = () => {
        updateControl();
        updateTransforms();
      };

      mobileQuery.addEventListener('change', handlePreferenceChange);
      reducedMotionQuery.addEventListener('change', handlePreferenceChange);

      root.addEventListener('shopify:section:unload', () => {
        window.cancelAnimationFrame(frameId);
        observer.disconnect();
      }, { once: true });

      updateControl();
      animate();
    };

    document.querySelectorAll('[data-aston-bestsellers]').forEach(initialize);

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-aston-bestsellers]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
